import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 relative max-w-lg w-full mx-4">
                <button
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-lg"
                    onClick={onClose}
                >
                    &times;
                </button>
                <div className="mt-4">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;